(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-purchase-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-subscription-purchase]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-product-form]');
      const variantInput = root.querySelector('[data-variant-id]');
      const sellingPlanInput = root.querySelector('[data-selling-plan]');
      const terms = root.querySelector('[data-subscription-terms]');
      const termsWrap = root.querySelector('[data-subscription-terms-wrap]');
      const error = root.querySelector('[data-form-error]');
      const buttonPrice = root.querySelector('[data-button-price]');
      const currentPrice = root.querySelector('[data-current-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const mediaPanels = [...root.querySelectorAll('[data-media-panel]')];
      const mediaButtons = [...root.querySelectorAll('[data-gallery-media]')];
      const thumbnailRail = root.querySelector('.subscription-purchase__thumbnails');
      const primaryMedia = root.querySelector('[data-primary-media]');
      const pairedProducts = root.dataset.purchaseMode === 'paired_products';
      const frequencyCopyNodes = [...root.querySelectorAll('[data-frequency-copy]')];
      const termsDialog = root.querySelector('[data-terms-dialog]');
      const termsFrame = root.querySelector('[data-terms-frame]');

      frequencyCopyNodes.forEach((node) => {
        node.dataset.frequencyTemplate = node.textContent.trim();
      });

      const updateFrequencyCopy = (planInput) => {
        const planLabel = planInput?.nextElementSibling?.textContent || planInput?.dataset.planName || '';
        const monthMatch = planLabel.match(/(\d+)\s*(?:mo(?:nth)?s?)/i);
        if (!monthMatch) return;
        const monthCount = Number(monthMatch[1]);
        const replacement = `every ${monthCount} ${monthCount === 1 ? 'month' : 'months'}`;
        frequencyCopyNodes.forEach((node) => {
          node.textContent = node.dataset.frequencyTemplate.replace(/every\s+\d+\s+months?/gi, replacement);
        });
      };

      const syncTermsState = (subscription) => {
        if (!terms) return;
        terms.required = subscription;
        terms.disabled = !subscription;
        terms.checked = subscription;
        if (termsWrap) termsWrap.hidden = !subscription;
      };

      const selectMedia = (mediaId) => {
        if (!mediaId) return false;
        const panel = mediaPanels.find((item) => item.dataset.mediaPanel === String(mediaId));
        if (!panel) return false;
        mediaPanels.forEach((item) => {
          const active = item === panel;
          item.classList.toggle('is-active', active);
          item.hidden = !active;
          if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        mediaButtons.forEach((item) => {
          const active = item.dataset.galleryMedia === String(mediaId);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && window.matchMedia('(max-width: 989px)').matches) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
        return true;
      };

      if (thumbnailRail) {
        let dragStartX = 0;
        let dragStartY = 0;
        let dragScrollLeft = 0;
        let dragScrollTop = 0;
        let isDragging = false;
        let suppressClick = false;
        let activePointerId = null;

        thumbnailRail.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          activePointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartY = event.clientY;
          dragScrollLeft = thumbnailRail.scrollLeft;
          dragScrollTop = thumbnailRail.scrollTop;
          isDragging = false;
          suppressClick = false;
        });
        thumbnailRail.addEventListener('pointermove', (event) => {
          if (activePointerId !== event.pointerId) return;
          const deltaX = event.clientX - dragStartX;
          const deltaY = event.clientY - dragStartY;
          const mobileRail = window.matchMedia('(max-width: 989px)').matches;
          if (!isDragging && mobileRail && Math.abs(deltaY) > Math.abs(deltaX)) {
            activePointerId = null;
            return;
          }
          if (!isDragging && Math.hypot(deltaX, deltaY) < 5) return;
          if (!isDragging) {
            isDragging = true;
            thumbnailRail.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          if (mobileRail) thumbnailRail.scrollLeft = dragScrollLeft - deltaX;
          else thumbnailRail.scrollTop = dragScrollTop - deltaY;
        });
        thumbnailRail.addEventListener('pointerup', (event) => {
          if (activePointerId !== event.pointerId) return;
          suppressClick = isDragging;
          if (thumbnailRail.hasPointerCapture(event.pointerId)) thumbnailRail.releasePointerCapture(event.pointerId);
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('pointercancel', () => {
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        }, true);
      }

      mediaButtons.forEach((button) => button.addEventListener('click', () => selectMedia(button.dataset.galleryMedia)));

      if (primaryMedia) {
        let mediaPointerId = null;
        let mediaStartX = 0;
        let mediaStartY = 0;
        let mediaDragging = false;
        let draggedPanel = null;

        const resetMediaDrag = () => {
          if (draggedPanel) {
            draggedPanel.style.transform = '';
            draggedPanel.style.transition = '';
          }
          draggedPanel = null;
          mediaDragging = false;
          mediaPointerId = null;
        };

        primaryMedia.addEventListener('pointerdown', (event) => {
          if (!window.matchMedia('(max-width: 989px)').matches || !event.isPrimary) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('video, iframe, model-viewer, button')) return;
          mediaPointerId = event.pointerId;
          mediaStartX = event.clientX;
          mediaStartY = event.clientY;
          mediaDragging = false;
          draggedPanel = root.querySelector('[data-media-panel].is-active');
        });
        primaryMedia.addEventListener('pointermove', (event) => {
          if (mediaPointerId !== event.pointerId || !draggedPanel) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          if (!mediaDragging && Math.abs(deltaY) > Math.abs(deltaX)) {
            resetMediaDrag();
            return;
          }
          if (!mediaDragging && Math.abs(deltaX) < 6) return;
          if (!mediaDragging) {
            mediaDragging = true;
            primaryMedia.setPointerCapture(event.pointerId);
            draggedPanel.style.transition = 'none';
          }
          event.preventDefault();
          draggedPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
        });
        primaryMedia.addEventListener('pointerup', (event) => {
          if (mediaPointerId !== event.pointerId) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          const currentIndex = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
          const shouldChange = mediaDragging && Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY);
          const nextIndex = shouldChange
            ? Math.max(0, Math.min(mediaPanels.length - 1, currentIndex + (deltaX < 0 ? 1 : -1)))
            : currentIndex;
          if (primaryMedia.hasPointerCapture(event.pointerId)) primaryMedia.releasePointerCapture(event.pointerId);
          resetMediaDrag();
          if (nextIndex !== currentIndex) selectMedia(mediaPanels[nextIndex].dataset.mediaPanel);
        });
        primaryMedia.addEventListener('pointercancel', resetMediaDrag);
      }

      root.querySelector('[data-product-share]')?.addEventListener('click', async () => {
        const shareData = { title: root.dataset.productTitle, url: window.location.href };
        const status = root.querySelector('[data-share-status]');
        try {
          if (navigator.share) await navigator.share(shareData);
          else {
            await navigator.clipboard.writeText(shareData.url);
            if (status) status.textContent = 'Link copied';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the page URL to share';
        }
        if (status?.textContent) window.setTimeout(() => { status.textContent = ''; }, 2400);
      });

      const modelTrigger = root.querySelector('[data-model-trigger]');
      const modelOverlay = root.querySelector('[data-external-model]');
      const modelViewer = root.querySelector('[data-model-viewer]');
      modelTrigger?.addEventListener('click', () => {
        const modelUrl = modelTrigger.dataset.modelUrl;
        if (modelUrl && modelOverlay && modelViewer) {
          modelViewer.setAttribute('src', modelUrl);
          modelOverlay.hidden = false;
          return;
        }
        selectMedia(modelTrigger.dataset.nativeModelId);
      });
      root.querySelector('[data-model-close]')?.addEventListener('click', () => {
        if (modelOverlay) modelOverlay.hidden = true;
        if (modelViewer) modelViewer.removeAttribute('src');
      });

      root.querySelectorAll('[data-variant-option]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-variant-option]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          variantInput.value = button.dataset.variantId;
          const subscriptionSelected = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (currentPrice) currentPrice.textContent = pairedProducts && subscriptionSelected ? root.dataset.subscriptionPrice : button.dataset.variantPrice;
          if (comparePrice) comparePrice.textContent = button.dataset.variantComparePrice;
          if (buttonPrice) buttonPrice.textContent = pairedProducts && subscriptionSelected ? root.dataset.subscriptionPrice : button.dataset.variantPrice;
          const submit = root.querySelector('[data-add-to-cart]');
          if (submit) submit.disabled = button.dataset.variantAvailable !== 'true';
          if (!selectMedia(button.dataset.variantMediaId) && button.dataset.variantImage) {
            const activeImage = root.querySelector('[data-media-panel].is-active img');
            if (activeImage) activeImage.src = button.dataset.variantImage;
          }
          if (modelTrigger) {
            modelTrigger.dataset.modelUrl = button.dataset.modelUrl || '';
            modelTrigger.hidden = !button.dataset.modelUrl && !modelTrigger.dataset.nativeModelId;
          }
        });
      });

      root.querySelectorAll('[data-plan-option]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!sellingPlanInput) return;
          sellingPlanInput.value = input.value;
          sellingPlanInput.disabled = false;
          updateFrequencyCopy(input);
          if (!pairedProducts && currentPrice) currentPrice.textContent = input.dataset.planPrice;
          if (!pairedProducts && buttonPrice) buttonPrice.textContent = input.dataset.planPrice;
        });
      });

      updateFrequencyCopy(root.querySelector('[data-plan-option]:checked'));
      syncTermsState(root.querySelector('[data-purchase-option]:checked')?.value === 'subscription');

      root.querySelector('[data-terms-open]')?.addEventListener('click', () => {
        if (!termsDialog || typeof termsDialog.showModal !== 'function') return;
        if (termsFrame && !termsFrame.getAttribute('src')) termsFrame.setAttribute('src', termsFrame.dataset.src);
        termsDialog.showModal();
      });
      root.querySelector('[data-terms-close]')?.addEventListener('click', () => termsDialog?.close());
      termsDialog?.addEventListener('click', (event) => {
        if (event.target === termsDialog) termsDialog.close();
      });

      root.querySelectorAll('[data-purchase-option]').forEach((input) => {
        input.addEventListener('change', () => {
          root.querySelectorAll('[data-purchase-card]').forEach((card) => card.classList.toggle('is-selected', card.dataset.purchaseCard === input.value));
          const subscription = input.value === 'subscription';
          if (sellingPlanInput) sellingPlanInput.disabled = !subscription;
          syncTermsState(subscription);
          if (!subscription) {
            const activeVariant = root.querySelector('[data-variant-option].is-active');
            if (currentPrice && activeVariant) currentPrice.textContent = activeVariant.dataset.variantPrice;
            if (buttonPrice && activeVariant) buttonPrice.textContent = activeVariant.dataset.variantPrice;
          } else if (pairedProducts) {
            if (currentPrice) currentPrice.textContent = root.dataset.subscriptionPrice;
            if (buttonPrice) buttonPrice.textContent = root.dataset.subscriptionPrice;
          } else {
            const activePlan = root.querySelector('[data-plan-option]:checked');
            if (!pairedProducts && buttonPrice && activePlan) buttonPrice.textContent = activePlan.dataset.planPrice;
          }
          if (error) error.hidden = true;
        });
      });

      if (form) {
        form.addEventListener('submit', async (event) => {
          const subscription = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (subscription && terms && !terms.checked) {
            event.preventDefault();
            error.hidden = false;
            terms.focus();
            return;
          }
          if (!pairedProducts) return;

          event.preventDefault();
          const submit = root.querySelector('[data-add-to-cart]');
          const mainVariantId = Number(variantInput?.value);
          const subscriptionVariantId = Number(root.dataset.subscriptionVariantId);
          const sellingPlanId = Number(sellingPlanInput?.value);
          if (!mainVariantId || (subscription && (!subscriptionVariantId || !sellingPlanId))) {
            if (error) {
              error.textContent = 'The selected subscription option is unavailable. Please refresh and try again.';
              error.hidden = false;
            }
            return;
          }

          const pairId = `ulike-subscription-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
          const items = subscription
            ? [
                {
                  id: mainVariantId,
                  quantity: 1,
                  properties: { _subscription_pair_id: pairId, _subscription_pair_role: 'main' }
                },
                {
                  id: subscriptionVariantId,
                  quantity: 1,
                  selling_plan: sellingPlanId,
                  properties: { _subscription_pair_id: pairId, _subscription_pair_role: 'subscription' }
                }
              ]
            : [{ id: mainVariantId, quantity: 1 }];

          if (submit) submit.disabled = true;
          if (error) error.hidden = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items, sections: ['mini-cart'], sections_url: window.location.pathname })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this plan to cart.');
            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, sections: result.sections, openMiniCart: true }
            }));
          } catch (submitError) {
            if (error) {
              error.textContent = submitError.message;
              error.hidden = false;
            }
          } finally {
            if (submit) submit.disabled = false;
          }
        });
      }

      const dialog = root.querySelector('[data-consult-dialog]');
      root.querySelector('[data-upsello-open]')?.addEventListener('click', () => {
        const detail = {
          product: root.dataset.productTitle,
          productHandle: root.dataset.productHandle,
          plan: root.dataset.planTitle,
          variantId: variantInput?.value,
          sellingPlanId: sellingPlanInput?.disabled ? null : sellingPlanInput?.value
        };
        window.dispatchEvent(new CustomEvent('upsello:open', { detail }));
        if (window.Upsello && typeof window.Upsello.open === 'function') {
          window.Upsello.open(detail);
          return;
        }
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
      root.querySelector('[data-consult-close]')?.addEventListener('click', () => dialog?.close());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-compatibility-checker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-compatibility-checker')) {
    customElements.define('ulike-compatibility-checker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-dialog]');
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.submitButton = this.querySelector('[data-submit]');
        this.formView = this.querySelector('[data-form-view]');
        this.resultView = this.querySelector('[data-result-view]');
        this.triggerSelector = `[data-compatibility-trigger="${CSS.escape(this.dataset.dialogId)}"]`;
        document.querySelectorAll(this.triggerSelector).forEach((trigger) => trigger.addEventListener('click', () => this.open(trigger)));
        this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-shop]')?.addEventListener('click', () => this.close(false));
        this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset(true));
        this.querySelectorAll('[data-option]').forEach((option) => option.addEventListener('click', () => this.select(option)));
        this.submitButton?.addEventListener('click', () => this.showResult());
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
        this.dialog?.addEventListener('close', () => { this.restoreFocus(); this.reset(false); });
      }

      open(trigger) {
        if (!this.dialog) return;
        this.trigger = trigger;
        this.dialog.showModal();
        this.querySelector('[data-close]')?.focus();
      }

      close(restoreFocus = true) {
        if (!this.dialog?.open) return;
        if (!restoreFocus) this.trigger = null;
        this.dialog.close();
      }

      restoreFocus() {
        this.trigger?.focus();
        this.trigger = null;
      }

      select(option) {
        const group = option.closest('[data-option-group]');
        group?.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
        this.submitButton.disabled = this.groups.some((item) => !item.querySelector('[data-option][aria-pressed="true"]'));
      }

      showResult() {
        const selected = this.groups.map((group) => group.querySelector('[data-option][aria-pressed="true"]'));
        if (selected.some((option) => !option)) return;
        const compatible = selected.every((option) => option.dataset.compatible === 'true');
        this.querySelectorAll('[data-result]').forEach((panel) => { panel.hidden = panel.dataset.result !== (compatible ? 'positive' : 'negative'); });
        this.formView.hidden = true;
        this.resultView.hidden = false;
        this.resultView.querySelector('[data-result]:not([hidden]) .heading')?.focus();
      }

      reset(focusFirst) {
        this.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('[data-result]').forEach((panel) => { panel.hidden = true; });
        this.formView.hidden = false;
        this.resultView.hidden = true;
        this.submitButton.disabled = true;
        if (focusFirst) this.querySelector('[data-option]')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-cp-before-after"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ulike-compare]').forEach((root)=>{if(root.dataset.ready)return;root.dataset.ready='true';const setPosition=(value)=>root.style.setProperty('--compare-position',`${value}%`);root.querySelectorAll('[data-compare-range]').forEach((range)=>range.addEventListener('input',()=>setPosition(range.value)));root.querySelectorAll('[data-compare-tab]').forEach((tab)=>tab.addEventListener('click',()=>{const id=tab.dataset.compareTab;root.querySelectorAll('[data-compare-tab]').forEach((item)=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',String(active))});root.querySelectorAll('[data-compare-panel]').forEach((panel)=>panel.hidden=panel.dataset.comparePanel!==id)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-cp-buy-box"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ulike-buy-box]').forEach((root)=>{if(root.dataset.ready)return;root.dataset.ready='true';const main=root.querySelector('.ulike-buybox__main-image');root.querySelectorAll('[data-gallery-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>{if(main){main.src=thumb.dataset.imageSrc;main.removeAttribute('srcset')}root.querySelectorAll('[data-gallery-thumb]').forEach((item)=>{item.classList.toggle('is-active',item===thumb);item.setAttribute('aria-pressed',String(item===thumb))})}));const variantInput=root.querySelector('[data-variant-input]');const planInput=root.querySelector('[data-selling-plan-input]');const price=root.querySelector('[data-current-price]');const addPrice=root.querySelector('[data-add-price]');const oneTimePrice=root.querySelector('[data-one-time-card-price]');const planCardPrice=root.querySelector('[data-plan-card-price]');const details=root.querySelector('[data-plan-details]');let mode=root.querySelector('[data-purchase-choice="plan"]')?'plan':'one-time';const setPrice=(value)=>{if(price)price.textContent=value;if(addPrice)addPrice.textContent=value};const choosePlan=(button)=>{if(!button)return;if(planInput){planInput.name='selling_plan';planInput.disabled=false;planInput.value=button.dataset.planId}button.closest('[data-plan-panel]')?.querySelectorAll('[data-plan-choice]').forEach((item)=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',String(item===button))});if(planCardPrice)planCardPrice.textContent=button.dataset.planPrice;setPrice(button.dataset.planPrice)};const updateMode=(next)=>{mode=next;root.querySelectorAll('[data-purchase-choice]').forEach((item)=>{const active=item.dataset.purchaseChoice===next;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});if(details)details.hidden=next!=='plan';if(next==='plan'){const panel=root.querySelector('[data-plan-panel]:not([hidden])');choosePlan(panel?.querySelector('[data-plan-choice].is-active')||panel?.querySelector('[data-plan-choice]'))}else{if(planInput){planInput.disabled=true;planInput.removeAttribute('name');planInput.value=''}const active=root.querySelector('[data-variant-choice].is-active');setPrice(active?.dataset.price||oneTimePrice?.textContent||'')}};root.querySelectorAll('[data-purchase-choice]').forEach((button)=>button.addEventListener('click',()=>updateMode(button.dataset.purchaseChoice)));root.querySelectorAll('[data-plan-choice]').forEach((button)=>button.addEventListener('click',()=>choosePlan(button)));root.querySelectorAll('[data-variant-choice]').forEach((button)=>button.addEventListener('click',()=>{root.querySelectorAll('[data-variant-choice]').forEach((item)=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',String(item===button))});if(variantInput)variantInput.value=button.dataset.variantId;if(oneTimePrice)oneTimePrice.textContent=button.dataset.price;root.querySelectorAll('[data-plan-panel]').forEach((panel)=>panel.hidden=panel.dataset.planPanel!==button.dataset.variantId);updateMode(mode)}));updateMode(mode)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-expert-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-expert-carousel')) {
    class UlikeExpertCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const card = this.viewport.querySelector('.ulike-experts__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.viewport.querySelector('.ulike-experts__track')).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-expert-carousel', UlikeExpertCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-logo-carousel')) {
    class UlikeLogoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const item = this.viewport.querySelector('.ulike-logo-carousel__item');
        const track = this.viewport.querySelector('.ulike-logo-carousel__track');
        if (!item || !track) return;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-logo-carousel', UlikeLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-media-tabs')) {
    customElements.define('ulike-media-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('[data-media-tab]')];
        this.panels = [...this.querySelectorAll('[data-media-panel]')];
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');
        this.index = 0;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
        this.previousButton?.addEventListener('click', () => this.select((this.index - 1 + this.tabs.length) % this.tabs.length));
        this.nextButton?.addEventListener('click', () => this.select((this.index + 1) % this.tabs.length));
        const panels = this.querySelector('[data-media-panels]');
        panels?.addEventListener('touchstart', (event) => { this.touch = event.touches[0]; }, { passive: true });
        panels?.addEventListener('touchend', (event) => {
          if (!this.touch || !event.changedTouches.length) return;
          const end = event.changedTouches[0];
          const horizontal = end.clientX - this.touch.clientX;
          const vertical = end.clientY - this.touch.clientY;
          if (Math.abs(horizontal) > 45 && Math.abs(horizontal) > Math.abs(vertical) * 1.2) this.select((this.index + (horizontal < 0 ? 1 : -1) + this.tabs.length) % this.tabs.length);
          this.touch = null;
        }, { passive: true });
        this.select(0);
      }

      select(index, focus = false) {
        this.index = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (focus) this.tabs[index]?.focus();
      }

      onKeydown(event, index) {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-proof-carousel')) {
    class UlikeProofCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-proof-tab], [data-proof-thumbnail]'));
        this.panels = Array.from(this.querySelectorAll('[data-proof-panel]'));
        this.usesThumbnailNavigation = this.hasAttribute('data-thumbnail-navigation') && this.querySelector('[data-proof-thumbnail]');
        if (this.tabs.length) {
          this.setAttribute('data-enhanced', '');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activateTab(index));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
          });
          this.activateTab(0);
        }
        this.querySelectorAll('[data-comparison]').forEach((comparison) => {
          const range = comparison.querySelector('[data-comparison-range]');
          if (!range) return;
          range.addEventListener('input', () => comparison.style.setProperty('--comparison-position', `${range.value}%`));
        });
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target.closest('[data-comparison-range]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.viewport);
        }
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      activateTab(index, focus = false) {
        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex]?.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (this.usesThumbnailNavigation) {
          const comparison = this.panels[index]?.querySelector('[data-comparison]');
          const range = comparison?.querySelector('[data-comparison-range]');
          if (comparison && range) {
            range.value = 50;
            comparison.style.setProperty('--comparison-position', '50%');
          }
          this.update();
        }
        if (focus) this.tabs[index]?.focus();
      }

      handleTabKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activateTab(nextIndex, true);
      }

      move(direction) {
        if (this.usesThumbnailNavigation) {
          const nextIndex = Math.min(this.tabs.length - 1, Math.max(0, (this.activeIndex || 0) + direction));
          this.activateTab(nextIndex, true);
          return;
        }
        const card = this.viewport.querySelector('.ulike-product-proof__comparison');
        const list = this.viewport.querySelector('.ulike-product-proof__results-list');
        if (!card || !list) return;
        const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        if (!this.previousButton || !this.nextButton) return;
        if (this.usesThumbnailNavigation) {
          this.previousButton.disabled = (this.activeIndex || 0) === 0;
          this.nextButton.disabled = (this.activeIndex || 0) === this.tabs.length - 1;
          return;
        }
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = maximum <= 2 || this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-proof-carousel', UlikeProofCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-technology-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-technology-showcase')) {
    customElements.define('ulike-technology-showcase', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        if (!this.scroller) return;
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.scroller.addEventListener('scroll', () => this.updateControls(), { passive: true });
        new ResizeObserver(() => this.updateControls()).observe(this.scroller);
        this.updateControls();
      }

      move(direction) {
        const card = this.scroller.querySelector('.ulike-technology-showcase__video-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateControls() {
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const position = Math.abs(this.scroller.scrollLeft);
        if (this.previousButton) this.previousButton.disabled = position <= 2;
        if (this.nextButton) this.nextButton.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
